import {useNavigate} from 'react-router-dom'
import Style from './style'
import scanIcon from 'shared/assets/scan-file.svg'
const ScanType = () => {
	const navigate = useNavigate()

	const handleOfficialTournament = () => {
		// Navigate to QR scan with tournament type
		navigate('/qr-scan/tournament')
	}

	const handleStoreEvent = () => {
		// Navigate to QR scan with store event type
		navigate('/qr-scan/store')
	}

	return (
		<Style.Container>
			<Style.ScanIcon src={scanIcon} alt='scan-icon' />

			<Style.Title>참가자 QR 코드를 스캔하기</Style.Title>

			<Style.InstructionsContainer>
				<Style.Instructions>
					입장권 QR 코드를 스캔하여 참가자의 자격을 확인하고 토너먼트 참가를
					관리하세요. 이벤트 유형을 선택하고 카메라 스캔을 사용하십시오.
				</Style.Instructions>
			</Style.InstructionsContainer>

			<Style.ActionContainer>
				<Style.Button onClick={handleOfficialTournament}>
					공식 토너먼트
				</Style.Button>

				<Style.OrContainer>
					<Style.OrText>or</Style.OrText>
				</Style.OrContainer>

				<Style.Button onClick={handleStoreEvent}>저장된 이벤트</Style.Button>
			</Style.ActionContainer>
		</Style.Container>
	)
}

export default ScanType
